import styled from 'styled-components';

export const StyledSubHeaderContainer: any = styled.div`
    color: grey;
    font-size: 1rem;
    font-weight: 500;
`;
